"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9926],{

/***/ 29926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useCountryStateFilters; },
  "g": function() { return /* binding */ getUserCountry; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(49980);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(49550);
// EXTERNAL MODULE: ./src/utils/countries.ts
var utils_countries = __webpack_require__(25655);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
;// CONCATENATED MODULE: ./src/shared/graphql/AvailableStatesWithCountriesQuery.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query AvailableStatesWithCountries {\n    availableStatesWithCountries {\n      country\n      state\n      friendlyStateName\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var AvailableStatesWithCountriesQuery = ((0,lib/* gql */.Ps)(_templateObject()));

// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
;// CONCATENATED MODULE: ./src/shared/hooks/useCountryStateFilters.ts





function useCountryStateFilters(input) {
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,useQuery/* useQuery */.a)(AvailableStatesWithCountriesQuery), data = ref.data, loading = ref.loading;
    var placeholders = {
        country: intl.formatMessage({
            defaultMessage: "Filter by country",
            id: "5YeTlf"
        }),
        state: getStateFilterPlaceholder(intl, input.country)
    };
    if (loading) {
        return {
            loading: true,
            countryOptions: [],
            stateOptions: [],
            defaultSelectedCountry: null,
            defaultSelectedState: null,
            cantFilterByState: false,
            placeholders: placeholders
        };
    }
    var availableStatesWithCountries = (data === null || data === void 0 ? void 0 : data.availableStatesWithCountries) || [];
    var countryOptions = getCountryOptions(availableStatesWithCountries);
    var stateOptions = getStateOptionsForCountry(availableStatesWithCountries, input.country);
    var defaultFilterOption = function(filterOptionValue, availableOptions, selectDefaultState) {
        if (!filterOptionValue) {
            if (!selectDefaultState) {
                return null;
            }
            if (isSectionedOptions(availableOptions)) {
                return {
                    label: availableOptions[0].options[0].label,
                    value: availableOptions[0].options[0].value
                };
            } else if (isFlatOptions(availableOptions)) {
                return {
                    label: availableOptions[0].label,
                    value: availableOptions[0].value
                };
            }
            return null;
        }
        var allOptions = [];
        if (isSectionedOptions(availableOptions)) {
            var _allOptions;
            allOptions = (_allOptions = allOptions).concat.apply(_allOptions, (0,_to_consumable_array/* default */.Z)(availableOptions.map(function(param) {
                var options = param.options;
                return options;
            })));
        } else if (isFlatOptions(availableOptions)) {
            allOptions = availableOptions;
        }
        return allOptions.find(function(candidate) {
            return candidate.value === filterOptionValue;
        }) || null;
    };
    return {
        loading: false,
        countryOptions: countryOptions,
        stateOptions: stateOptions,
        defaultSelectedCountry: defaultFilterOption(input.country, countryOptions),
        defaultSelectedState: defaultFilterOption(input.state, stateOptions, input.selectDefaultState),
        cantFilterByState: ![
            "US",
            "CA",
            "ZA",
            "AU",
            "IE",
            "BR",
            "DE",
            "MX",
            "AR",
            "IT",
            "NL",
            "DK",
            "NZ",
            "GB",
            "SE",
            "FI", 
        ].includes(input.country),
        placeholders: placeholders
    };
};
function isSectionedOptions(value) {
    return Array.isArray(value) && value.length > 0 && value[0].section;
}
function isFlatOptions(value) {
    return Array.isArray(value) && value.length > 0 && value[0].value;
}
function getCountryOptions(statesWithCountriesData) {
    var countries = statesWithCountriesData.map(function(stateWithCountry) {
        return stateWithCountry.country;
    });
    return Array.from(new Set(countries)).map(function(countryCode) {
        return {
            label: (0,utils_countries/* findCountryNameByCode */.u5)(countryCode) || "",
            value: countryCode
        };
    }).sort(sortAlphabetically);
}
function getStateOptionsForCountry(statesWithCountriesData, forCountry) {
    var makeFilterOption = function(param) {
        var friendlyStateName = param.friendlyStateName, state = param.state;
        return {
            label: friendlyStateName,
            value: state
        };
    };
    if (forCountry !== "US") {
        return statesWithCountriesData.filter(function(param) {
            var country = param.country;
            return country === forCountry;
        }).map(makeFilterOption).sort(sortAlphabetically);
    }
    var unitedStates = statesWithCountriesData.filter(function(param) {
        var country = param.country;
        return country === "US";
    });
    var territories = [
        "GU",
        "PR",
        "YT",
        "NT",
        "NU"
    ];
    return [
        {
            section: "State",
            options: unitedStates.filter(function(param) {
                var state = param.state;
                return !territories.includes(state);
            }).map(makeFilterOption).sort(sortAlphabetically)
        },
        {
            section: "Territories",
            options: unitedStates.filter(function(param) {
                var state = param.state;
                return territories.includes(state);
            }).map(makeFilterOption).sort(sortAlphabetically)
        }, 
    ];
}
function getStateFilterPlaceholder(intl, country) {
    if (country === "US") {
        return intl.formatMessage({
            defaultMessage: "Filter by State/Territory...",
            id: "REIo7m"
        });
    }
    if (country === "CA" || country === "ZA") {
        return intl.formatMessage({
            defaultMessage: "Filter by Province...",
            id: "hH7+0+"
        });
    }
    if (country === "AU") {
        return intl.formatMessage({
            defaultMessage: "Filter by State...",
            id: "qGg0Vb"
        });
    }
    if (country === "IE") {
        return intl.formatMessage({
            defaultMessage: "Filter by Region...",
            id: "HvuZrV"
        });
    }
    return intl.formatMessage({
        defaultMessage: "Filter by State/Territory/Province...",
        id: "wIceQ1"
    });
}
function sortAlphabetically(a, b) {
    return a.label.localeCompare(b.label);
}
function getUserCountry(user) {
    if (!user) {
        return "";
    }
    if (user.signInAttempts && user.signInAttempts[0] && user.signInAttempts[0].lookup && user.signInAttempts[0].lookup.country_code) {
        return user.signInAttempts[0].lookup.country_code;
    }
    return "";
}


/***/ }),

/***/ 25655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "od": function() { return /* binding */ COUNTRIES; },
/* harmony export */   "u5": function() { return /* binding */ findCountryNameByCode; }
/* harmony export */ });
var COUNTRIES = [
    {
        code: "AF",
        name: "Afghanistan"
    },
    {
        code: "AX",
        name: "\xc5land Islands"
    },
    {
        code: "AL",
        name: "Albania"
    },
    {
        code: "DZ",
        name: "Algeria"
    },
    {
        code: "AS",
        name: "American Samoa"
    },
    {
        code: "AD",
        name: "Andorra"
    },
    {
        code: "AO",
        name: "Angola"
    },
    {
        code: "AI",
        name: "Anguilla"
    },
    {
        code: "AQ",
        name: "Antarctica"
    },
    {
        code: "AG",
        name: "Antigua and Barbuda"
    },
    {
        code: "AR",
        name: "Argentina"
    },
    {
        code: "AM",
        name: "Armenia"
    },
    {
        code: "AW",
        name: "Aruba"
    },
    {
        code: "AU",
        name: "Australia"
    },
    {
        code: "AT",
        name: "Austria"
    },
    {
        code: "AZ",
        name: "Azerbaijan"
    },
    {
        code: "BS",
        name: "Bahamas"
    },
    {
        code: "BH",
        name: "Bahrain"
    },
    {
        code: "BD",
        name: "Bangladesh"
    },
    {
        code: "BB",
        name: "Barbados"
    },
    {
        code: "BY",
        name: "Belarus"
    },
    {
        code: "BE",
        name: "Belgium"
    },
    {
        code: "BZ",
        name: "Belize"
    },
    {
        code: "BJ",
        name: "Benin"
    },
    {
        code: "BM",
        name: "Bermuda"
    },
    {
        code: "BT",
        name: "Bhutan"
    },
    {
        code: "BO",
        name: "Bolivia, Plurinational State of"
    },
    {
        code: "BQ",
        name: "Bonaire, Sint Eustatius and Saba"
    },
    {
        code: "BA",
        name: "Bosnia and Herzegovina"
    },
    {
        code: "BW",
        name: "Botswana"
    },
    {
        code: "BV",
        name: "Bouvet Island"
    },
    {
        code: "BR",
        name: "Brazil"
    },
    {
        code: "IO",
        name: "British Indian Ocean Territory"
    },
    {
        code: "BN",
        name: "Brunei Darussalam"
    },
    {
        code: "BG",
        name: "Bulgaria"
    },
    {
        code: "BF",
        name: "Burkina Faso"
    },
    {
        code: "BI",
        name: "Burundi"
    },
    {
        code: "KH",
        name: "Cambodia"
    },
    {
        code: "CM",
        name: "Cameroon"
    },
    {
        code: "CA",
        name: "Canada"
    },
    {
        code: "CV",
        name: "Cape Verde"
    },
    {
        code: "KY",
        name: "Cayman Islands"
    },
    {
        code: "CF",
        name: "Central African Republic"
    },
    {
        code: "TD",
        name: "Chad"
    },
    {
        code: "CL",
        name: "Chile"
    },
    {
        code: "CN",
        name: "China"
    },
    {
        code: "CX",
        name: "Christmas Island"
    },
    {
        code: "CC",
        name: "Cocos (Keeling) Islands"
    },
    {
        code: "CO",
        name: "Colombia"
    },
    {
        code: "KM",
        name: "Comoros"
    },
    {
        code: "CG",
        name: "Congo"
    },
    {
        code: "CD",
        name: "Congo, the Democratic Republic of the"
    },
    {
        code: "CK",
        name: "Cook Islands"
    },
    {
        code: "CR",
        name: "Costa Rica"
    },
    {
        code: "CI",
        name: "C\xf4te d'Ivoire"
    },
    {
        code: "HR",
        name: "Croatia"
    },
    {
        code: "CU",
        name: "Cuba"
    },
    {
        code: "CW",
        name: "Cura\xe7ao"
    },
    {
        code: "CY",
        name: "Cyprus"
    },
    {
        code: "CZ",
        name: "Czech Republic"
    },
    {
        code: "DK",
        name: "Denmark"
    },
    {
        code: "DJ",
        name: "Djibouti"
    },
    {
        code: "DM",
        name: "Dominica"
    },
    {
        code: "DO",
        name: "Dominican Republic"
    },
    {
        code: "EC",
        name: "Ecuador"
    },
    {
        code: "EG",
        name: "Egypt"
    },
    {
        code: "SV",
        name: "El Salvador"
    },
    {
        code: "GQ",
        name: "Equatorial Guinea"
    },
    {
        code: "ER",
        name: "Eritrea"
    },
    {
        code: "EE",
        name: "Estonia"
    },
    {
        code: "ET",
        name: "Ethiopia"
    },
    {
        code: "FK",
        name: "Falkland Islands (Malvinas)"
    },
    {
        code: "FO",
        name: "Faroe Islands"
    },
    {
        code: "FJ",
        name: "Fiji"
    },
    {
        code: "FI",
        name: "Finland"
    },
    {
        code: "FR",
        name: "France"
    },
    {
        code: "GF",
        name: "French Guiana"
    },
    {
        code: "PF",
        name: "French Polynesia"
    },
    {
        code: "TF",
        name: "French Southern Territories"
    },
    {
        code: "GA",
        name: "Gabon"
    },
    {
        code: "GM",
        name: "Gambia"
    },
    {
        code: "GE",
        name: "Georgia"
    },
    {
        code: "DE",
        name: "Germany"
    },
    {
        code: "GH",
        name: "Ghana"
    },
    {
        code: "GI",
        name: "Gibraltar"
    },
    {
        code: "GR",
        name: "Greece"
    },
    {
        code: "GL",
        name: "Greenland"
    },
    {
        code: "GD",
        name: "Grenada"
    },
    {
        code: "GP",
        name: "Guadeloupe"
    },
    {
        code: "GU",
        name: "Guam"
    },
    {
        code: "GT",
        name: "Guatemala"
    },
    {
        code: "GG",
        name: "Guernsey"
    },
    {
        code: "GN",
        name: "Guinea"
    },
    {
        code: "GW",
        name: "Guinea-Bissau"
    },
    {
        code: "GY",
        name: "Guyana"
    },
    {
        code: "HT",
        name: "Haiti"
    },
    {
        code: "HM",
        name: "Heard Island and McDonald Islands"
    },
    {
        code: "VA",
        name: "Holy See (Vatican City State)"
    },
    {
        code: "HN",
        name: "Honduras"
    },
    {
        code: "HK",
        name: "Hong Kong"
    },
    {
        code: "HU",
        name: "Hungary"
    },
    {
        code: "IS",
        name: "Iceland"
    },
    {
        code: "IN",
        name: "India"
    },
    {
        code: "ID",
        name: "Indonesia"
    },
    {
        code: "IR",
        name: "Iran, Islamic Republic of"
    },
    {
        code: "IQ",
        name: "Iraq"
    },
    {
        code: "IE",
        name: "Ireland"
    },
    {
        code: "IM",
        name: "Isle of Man"
    },
    {
        code: "IL",
        name: "Israel"
    },
    {
        code: "IT",
        name: "Italy"
    },
    {
        code: "JM",
        name: "Jamaica"
    },
    {
        code: "JP",
        name: "Japan"
    },
    {
        code: "JE",
        name: "Jersey"
    },
    {
        code: "JO",
        name: "Jordan"
    },
    {
        code: "KZ",
        name: "Kazakhstan"
    },
    {
        code: "KE",
        name: "Kenya"
    },
    {
        code: "KI",
        name: "Kiribati"
    },
    {
        code: "KP",
        name: "Korea, Democratic People's Republic of"
    },
    {
        code: "KR",
        name: "Korea, Republic of"
    },
    {
        code: "KW",
        name: "Kuwait"
    },
    {
        code: "KG",
        name: "Kyrgyzstan"
    },
    {
        code: "LA",
        name: "Lao People's Democratic Republic"
    },
    {
        code: "LV",
        name: "Latvia"
    },
    {
        code: "LB",
        name: "Lebanon"
    },
    {
        code: "LS",
        name: "Lesotho"
    },
    {
        code: "LR",
        name: "Liberia"
    },
    {
        code: "LY",
        name: "Libya"
    },
    {
        code: "LI",
        name: "Liechtenstein"
    },
    {
        code: "LT",
        name: "Lithuania"
    },
    {
        code: "LU",
        name: "Luxembourg"
    },
    {
        code: "MO",
        name: "Macao"
    },
    {
        code: "MK",
        name: "Macedonia, the Former Yugoslav Republic of"
    },
    {
        code: "MG",
        name: "Madagascar"
    },
    {
        code: "MW",
        name: "Malawi"
    },
    {
        code: "MY",
        name: "Malaysia"
    },
    {
        code: "MV",
        name: "Maldives"
    },
    {
        code: "ML",
        name: "Mali"
    },
    {
        code: "MT",
        name: "Malta"
    },
    {
        code: "MH",
        name: "Marshall Islands"
    },
    {
        code: "MQ",
        name: "Martinique"
    },
    {
        code: "MR",
        name: "Mauritania"
    },
    {
        code: "MU",
        name: "Mauritius"
    },
    {
        code: "YT",
        name: "Mayotte"
    },
    {
        code: "MX",
        name: "Mexico"
    },
    {
        code: "FM",
        name: "Micronesia, Federated States of"
    },
    {
        code: "MD",
        name: "Moldova, Republic of"
    },
    {
        code: "MC",
        name: "Monaco"
    },
    {
        code: "MN",
        name: "Mongolia"
    },
    {
        code: "ME",
        name: "Montenegro"
    },
    {
        code: "MS",
        name: "Montserrat"
    },
    {
        code: "MA",
        name: "Morocco"
    },
    {
        code: "MZ",
        name: "Mozambique"
    },
    {
        code: "MM",
        name: "Myanmar"
    },
    {
        code: "NA",
        name: "Namibia"
    },
    {
        code: "NR",
        name: "Nauru"
    },
    {
        code: "NP",
        name: "Nepal"
    },
    {
        code: "NL",
        name: "Netherlands"
    },
    {
        code: "NC",
        name: "New Caledonia"
    },
    {
        code: "NZ",
        name: "New Zealand"
    },
    {
        code: "NI",
        name: "Nicaragua"
    },
    {
        code: "NE",
        name: "Niger"
    },
    {
        code: "NG",
        name: "Nigeria"
    },
    {
        code: "NU",
        name: "Niue"
    },
    {
        code: "NF",
        name: "Norfolk Island"
    },
    {
        code: "MP",
        name: "Northern Mariana Islands"
    },
    {
        code: "NO",
        name: "Norway"
    },
    {
        code: "OM",
        name: "Oman"
    },
    {
        code: "PK",
        name: "Pakistan"
    },
    {
        code: "PW",
        name: "Palau"
    },
    {
        code: "PS",
        name: "Palestine, State of"
    },
    {
        code: "PA",
        name: "Panama"
    },
    {
        code: "PG",
        name: "Papua New Guinea"
    },
    {
        code: "PY",
        name: "Paraguay"
    },
    {
        code: "PE",
        name: "Peru"
    },
    {
        code: "PH",
        name: "Philippines"
    },
    {
        code: "PN",
        name: "Pitcairn"
    },
    {
        code: "PL",
        name: "Poland"
    },
    {
        code: "PT",
        name: "Portugal"
    },
    {
        code: "PR",
        name: "Puerto Rico"
    },
    {
        code: "QA",
        name: "Qatar"
    },
    {
        code: "RE",
        name: "R\xe9union"
    },
    {
        code: "RO",
        name: "Romania"
    },
    {
        code: "RU",
        name: "Russian Federation"
    },
    {
        code: "RW",
        name: "Rwanda"
    },
    {
        code: "BL",
        name: "Saint Barth\xe9lemy"
    },
    {
        code: "SH",
        name: "Saint Helena, Ascension and Tristan da Cunha"
    },
    {
        code: "KN",
        name: "Saint Kitts and Nevis"
    },
    {
        code: "LC",
        name: "Saint Lucia"
    },
    {
        code: "MF",
        name: "Saint Martin (French part)"
    },
    {
        code: "PM",
        name: "Saint Pierre and Miquelon"
    },
    {
        code: "VC",
        name: "Saint Vincent and the Grenadines"
    },
    {
        code: "WS",
        name: "Samoa"
    },
    {
        code: "SM",
        name: "San Marino"
    },
    {
        code: "ST",
        name: "Sao Tome and Principe"
    },
    {
        code: "SA",
        name: "Saudi Arabia"
    },
    {
        code: "SN",
        name: "Senegal"
    },
    {
        code: "RS",
        name: "Serbia"
    },
    {
        code: "SC",
        name: "Seychelles"
    },
    {
        code: "SL",
        name: "Sierra Leone"
    },
    {
        code: "SG",
        name: "Singapore"
    },
    {
        code: "SX",
        name: "Sint Maarten (Dutch part)"
    },
    {
        code: "SK",
        name: "Slovakia"
    },
    {
        code: "SI",
        name: "Slovenia"
    },
    {
        code: "SB",
        name: "Solomon Islands"
    },
    {
        code: "SO",
        name: "Somalia"
    },
    {
        code: "ZA",
        name: "South Africa"
    },
    {
        code: "GS",
        name: "South Georgia and the South Sandwich Islands"
    },
    {
        code: "SS",
        name: "South Sudan"
    },
    {
        code: "ES",
        name: "Spain"
    },
    {
        code: "LK",
        name: "Sri Lanka"
    },
    {
        code: "SD",
        name: "Sudan"
    },
    {
        code: "SR",
        name: "Suriname"
    },
    {
        code: "SJ",
        name: "Svalbard and Jan Mayen"
    },
    {
        code: "SZ",
        name: "Swaziland"
    },
    {
        code: "SE",
        name: "Sweden"
    },
    {
        code: "CH",
        name: "Switzerland"
    },
    {
        code: "SY",
        name: "Syrian Arab Republic"
    },
    {
        code: "TW",
        name: "Taiwan, Province of China"
    },
    {
        code: "TJ",
        name: "Tajikistan"
    },
    {
        code: "TZ",
        name: "Tanzania, United Republic of"
    },
    {
        code: "TH",
        name: "Thailand"
    },
    {
        code: "TL",
        name: "Timor-Leste"
    },
    {
        code: "TG",
        name: "Togo"
    },
    {
        code: "TK",
        name: "Tokelau"
    },
    {
        code: "TO",
        name: "Tonga"
    },
    {
        code: "TT",
        name: "Trinidad and Tobago"
    },
    {
        code: "TN",
        name: "Tunisia"
    },
    {
        code: "TR",
        name: "Turkey"
    },
    {
        code: "TM",
        name: "Turkmenistan"
    },
    {
        code: "TC",
        name: "Turks and Caicos Islands"
    },
    {
        code: "TV",
        name: "Tuvalu"
    },
    {
        code: "UG",
        name: "Uganda"
    },
    {
        code: "UA",
        name: "Ukraine"
    },
    {
        code: "AE",
        name: "United Arab Emirates"
    },
    {
        code: "GB",
        name: "United Kingdom"
    },
    {
        code: "US",
        name: "United States"
    },
    {
        code: "UM",
        name: "United States Minor Outlying Islands"
    },
    {
        code: "UY",
        name: "Uruguay"
    },
    {
        code: "UZ",
        name: "Uzbekistan"
    },
    {
        code: "VU",
        name: "Vanuatu"
    },
    {
        code: "VE",
        name: "Venezuela, Bolivarian Republic of"
    },
    {
        code: "VN",
        name: "Viet Nam"
    },
    {
        code: "VG",
        name: "Virgin Islands, British"
    },
    {
        code: "VI",
        name: "Virgin Islands, U.S."
    },
    {
        code: "WF",
        name: "Wallis and Futuna"
    },
    {
        code: "EH",
        name: "Western Sahara"
    },
    {
        code: "YE",
        name: "Yemen"
    },
    {
        code: "ZM",
        name: "Zambia"
    },
    {
        code: "ZW",
        name: "Zimbabwe"
    }, 
];
function findCountryNameByCode(isoCode) {
    var ref;
    return ((ref = COUNTRIES.find(function(country) {
        return country.code === isoCode;
    })) === null || ref === void 0 ? void 0 : ref.name) || null;
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (COUNTRIES)));


/***/ })

}]);